import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import { ISubjectContact } from '../../../pages/HelpAndSupport/interfaces';
import SubjectContactMapper from '../mappers/SubjectContactMapper';

class SubjectHelpAndSupportService {
    private baseURL: string = `${urlHttpGov}/panel/subject-contact`;

    async listSubjects(signal: AbortSignal): Promise<Array<ISubjectContact>> {
        const { data } = await privateHttpClient.get(this.baseURL, { signal });

        return data.map((subject: any) => SubjectContactMapper.toDomain(subject));
    }

    createSubject(subjectName: string) {
        return privateHttpClient.post(this.baseURL, {
            name: subjectName
        });
    }

    async getSubjectById(id: number, signal: AbortSignal): Promise<ISubjectContact> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${id}`, { signal });

        return SubjectContactMapper.toDomain(data);
    }

    async updateSubject(id: number, subject: { name: string } | FormData | any): Promise<ISubjectContact> {
        const { data } = await privateHttpClient.put(`${this.baseURL}/${id}`, subject);

        return SubjectContactMapper.toDomain(data);
    }

    deleteSubject(id: number) {
        return privateHttpClient.delete(`${this.baseURL}/${id}`);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SubjectHelpAndSupportService();
